import { createContext, ReactNode, useContext } from 'react';
import { EditorActions } from '@atlaskit/editor-core';

const EditorActionsContext = createContext<EditorActions | null>(null);

export const useEditorActions = () => {
  const context = useContext(EditorActionsContext);
  if (!context) {
    throw new Error(
      'useEditorActions must be used within a EditorActionsProvider'
    );
  }
  return context;
};

export const EditorActionsProvider = ({
  children,
  actions
}: {
  children: ReactNode;
  actions: EditorActions;
}) => {
  return (
    <EditorActionsContext.Provider value={actions}>
      {children}
    </EditorActionsContext.Provider>
  );
};
